module.exports = __webpack_public_path__ + "static/installationspartner-footerBanner-min-a7a1cc7dec146c910010701146d6b11d.jpg";